import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutTitleStyled } from '../CheckoutTitleStyled';

export const CheckoutTitleStyledAP = styled(CheckoutTitleStyled)`
    font-size: ${({ theme }) => theme.fontSizes.h5};
    font-weight: ${({ theme }) => theme.fontWeights.textRegular};

    @media (min-width: ${breakpoints.sm}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }
`;
